// extracted by mini-css-extract-plugin
export default {"booking":"Booking_booking__OaJ8z"};